// ───────────────────────────────────────────────────────────────
// TikTok Pixel — helper para disparar eventos de forma segura.
// El pixel base se carga en public/index.html (window.ttq).
// Si por lo que sea no cargó (adblock, etc.), estas llamadas
// no rompen nada: simplemente no hacen nada.
// ───────────────────────────────────────────────────────────────

export const ttqTrack = (event, params) => {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.track === "function") {
      window.ttq.track(event, params || {});
    }
  } catch (_) {
    /* noop — nunca dejamos que analítica rompa la tienda */
  }
};

// Identificador del producto para agrupar eventos en TikTok Ads.
export const TTQ_CONTENT = {
  content_id: "fullstop-cargador",
  content_type: "product",
  content_name: "Cargador Inteligente FullStop",
};
